import {
    LOGOUT,
    SELECT_CUSTOMER,
} from '../../constants/actions/auth.constants';
import ProfileActionConstants from '../../constants/actions/ProfileActionConstants';
import { AuthService } from '../../services/AuthService';

export default function profile(state: object | null = null, action) {
    switch (action.type) {
        case ProfileActionConstants.GET_PROFILE_SUCCESS:
            return action.payload;
        case SELECT_CUSTOMER: {
            const { accessToken } = action.payload;
            const data = AuthService.decodeUserData(accessToken);
            if (!data) {
                return state;
            }

            const { email, firstName, lastName } = data;

            return { ...state, email, firstName, lastName };
        }
        case LOGOUT:
            return null;
        default:
            return state;
    }
}
